/* Tool 2: Indian diabetes diet plan generator. Registers into window.SKT2 (assets/sk-tools2.js).
   Meals come from assets/sk-meals-data.js. Everything runs in the browser; nothing a visitor types is stored or sent.
   Energy: Mifflin-St Jeor BMR x activity, minus 500 kcal to lose weight, floor 1,200 (women) / 1,500 (men), rounded to the nearest 100.
   Each slot's meal is scaled in quarter portions to hit its share of the day (b 25%, m 10%, l 30%, s 10%, d 25%). */
(function () {
  'use strict';
  var S = window.SKT2, D = window.SK_MEALS; if (!S || !D) return;
  var H = S.helpers, q = H.q, esc = H.esc, round = H.round, L = H.LINKS;
  var SLOTS = ['b', 'm', 'l', 's', 'd'], SHARE = { b: 0.25, m: 0.10, l: 0.30, s: 0.10, d: 0.25 }, NAMES = D.slots;
  var JAIN_NO = ['onion', 'potato', 'sweet potato', 'carrot', 'mushroom', 'ginger', 'garlic', 'beetroot'];
  var DAYS = ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7'];

  var meals = D.lines.map(function (ln, i) {
    var f = ln.split('|');
    var m = { id: i, name: f[0], slot: f[1], diet: f[2], reg: f[3], flags: f[4], serving: f[5], c: +f[6], p: +f[7], f: +f[8], fib: +f[9], gi: f[10], groc: f[11].split(',') };
    m.kcal = 4 * m.c + 4 * m.p + 9 * m.f;
    return m;
  });

  var groupOf = {};
  Object.keys(D.groups).forEach(function (g) { D.groups[g].forEach(function (it) { groupOf[it] = g; }); });

  function rng(seed) { // small deterministic generator so the same answers give the same plan
    var a = seed >>> 0;
    return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; };
  }
  function qtr(x) { return Math.round(x * 4) / 4; }
  function fracText(k) {
    var w = Math.floor(k), r = round(k - w, 2), s = { 0: '', 0.25: '&frac14;', 0.5: '&frac12;', 0.75: '&frac34;' }[r];
    return (w ? w : '') + (w && s ? ' ' : '') + s;
  }

  /* does a meal suit the visitor? */
  function suits(m, o) {
    if (o.diet === 'v' || o.diet === 'j') { if (m.diet !== 'v') return false; }
    else if (o.diet === 'e') { if (m.diet === 'n') return false; }
    if (o.diet === 'j') {
      if (m.flags.indexOf('o') > -1 || m.flags.indexOf('r') > -1) return false;
      for (var i = 0; i < m.groc.length; i++) if (JAIN_NO.indexOf(m.groc[i]) > -1) return false;
    }
    if (o.noDairy && m.flags.indexOf('d') > -1) return false;
    if (o.noGluten && m.flags.indexOf('g') > -1) return false;
    if (o.noNuts && m.flags.indexOf('n') > -1) return false;
    if (o.noOnion && m.flags.indexOf('o') > -1) return false;
    return true;
  }
  function regionOk(m, region) { return region === 'M' || m.reg.indexOf('A') > -1 || m.reg.indexOf(region) > -1; }

  function pools(o) {
    var out = {};
    SLOTS.forEach(function (s) {
      var base = meals.filter(function (m) { return m.slot === s && suits(m, o); });
      var reg = base.filter(function (m) { return regionOk(m, o.region); });
      out[s] = reg.length >= 8 ? reg : base; // too few for this region: relax it for this slot
    });
    return out;
  }

  function dayTotals(day) {
    var t = { kcal: 0, c: 0, p: 0, f: 0, fib: 0 };
    SLOTS.forEach(function (s) { var e = day[s], m = e.m; t.kcal += m.kcal * e.k; t.c += m.c * e.k; t.p += m.p * e.k; t.f += m.f * e.k; t.fib += m.fib * e.k; });
    return t;
  }
  /* nudge the quarter-portions until the day is as close to the target as possible */
  function tune(day, target) {
    for (var it = 0; it < 14; it++) {
      var cur = dayTotals(day).kcal, err = Math.abs(cur - target), best = null, bestErr = err;
      if (err <= target * 0.02) return;
      SLOTS.forEach(function (s) {
        [-0.25, 0.25].forEach(function (d) {
          var e = day[s], k = e.k + d; if (k < 0.5 || k > 2) return;
          var next = cur + d * e.m.kcal, ne = Math.abs(next - target);
          if (ne < bestErr) { bestErr = ne; best = [s, k]; }
        });
      });
      if (!best) return;
      day[best[0]].k = best[1];
    }
  }
  function pick(list, rand, avoidIds, recentIds, target) {
    var ok = list.filter(function (m) { var r = target * 1 / m.kcal; return r >= 0.6 && r <= 1.75; });
    if (!ok.length) ok = list;
    var fresh = ok.filter(function (m) { return recentIds.indexOf(m.id) < 0; });
    if (!fresh.length) fresh = ok;
    var unused = fresh.filter(function (m) { return avoidIds.indexOf(m.id) < 0; });
    var from = unused.length ? unused : fresh;
    return from[Math.floor(rand() * from.length)];
  }
  function makeDay(P, target, rand, history, usedAll) {
    var best = null, bestScore = 1e9;
    for (var a = 0; a < 40; a++) {
      var day = {};
      SLOTS.forEach(function (s) {
        var slotKcal = target * SHARE[s], recent = [];
        for (var d = Math.max(0, history.length - 2); d < history.length; d++) recent.push(history[d][s].m.id);
        var m = pick(P[s], rand, usedAll, recent, slotKcal);
        day[s] = { m: m, k: Math.max(0.5, Math.min(2, qtr(slotKcal / m.kcal))) };
      });
      tune(day, target);
      var t = dayTotals(day), err = Math.abs(t.kcal - target) / target, cp = t.c * 4 / t.kcal;
      var score = err + (cp > 0.50 ? (cp - 0.50) * 2 : 0) + (cp < 0.45 ? (0.45 - cp) * 2 : 0);
      if (score < bestScore) { bestScore = score; best = day; }
      if (err <= 0.05 && cp <= 0.50 && cp >= 0.45) break;
    }
    return best;
  }
  function buildPlan(o, target, seed) {
    var P = pools(o), rand = rng(seed), plan = [], used = [];
    for (var d = 0; d < 7; d++) {
      var day = makeDay(P, target, rand, plan, used);
      plan.push(day);
      SLOTS.forEach(function (s) { used.push(day[s].m.id); });
    }
    return { days: plan, pools: P, rand: rand, target: target };
  }

  function mealLine(e) {
    var m = e.m, k = e.k;
    return { kcal: Math.round(m.kcal * k), carbs: round(m.c * k, 0), portion: k === 1 ? '1 serving' : fracText(k) + ' serving' + (k > 1 ? 's' : '') };
  }

  function grocery(plan) {
    var count = {};
    plan.days.forEach(function (day) { SLOTS.forEach(function (s) { day[s].m.groc.forEach(function (g) { count[g] = (count[g] || 0) + 1; }); }); });
    var groups = {};
    Object.keys(count).forEach(function (g) { var cat = groupOf[g] || 'Spices and others'; (groups[cat] = groups[cat] || []).push(g); });
    return Object.keys(D.groups).filter(function (c) { return groups[c]; }).map(function (c) {
      return { cat: c, items: groups[c].sort().map(function (g) { return { name: g, n: count[g] }; }) };
    });
  }

  S.tools.dietplan = function (root) {
    var state = null;
    var r = H.frame(root, 'dietplan',
      '<div class="tl-grid2">' + H.fld('Sex', H.seg('sex', [['m', 'Male'], ['f', 'Female']], 'f')) + H.fld('Height unit', H.seg('hu', [['cm', 'cm'], ['ft', 'ft and in']], 'cm')) + '</div>' +
      '<div class="tl-grid2">' + H.nf('age', 'Age', 'years', null, { min: 18, max: 90, step: 1, def: 45 }) + H.nf('w', 'Weight', 'kg', null, { min: 30, max: 200, step: 0.5, def: 70 }) + '</div>' +
      '<div class="tl-grid2" id="hrow">' + H.nf('h', 'Height', 'cm', null, { min: 120, max: 220, step: 1, def: 160 }) + '</div>' +
      H.fld('Activity', H.seg('act', [['1.2', 'Mostly sitting'], ['1.375', 'Light: walks, light chores'], ['1.55', 'Moderate: exercise 3 to 5 days'], ['1.725', 'Very active']], '1.375', 'tl-ropts')) +
      H.fld('Diet type', H.seg('diet', [['v', 'Vegetarian'], ['e', 'Eggetarian'], ['n', 'Non-vegetarian'], ['j', 'Jain']], 'v')) +
      H.fld('Regional style', H.seg('reg', [['N', 'North'], ['S', 'South'], ['E', 'East'], ['W', 'West'], ['M', 'Mixed']], 'M')) +
      H.fld('Goal', H.seg('goal', [['0', 'Keep my weight'], ['-500', 'Lose weight']], '-500')) +
      '<div class="tl-field"><label>Avoid (optional)</label><small>Plans never include milk or milk products (curd, paneer, buttermilk).</small>' +
      '<label class="t2-check"><input type="checkbox" id="av-gluten"> Gluten (wheat, oats, rava)</label>' +
      '<label class="t2-check"><input type="checkbox" id="av-nuts"> Nuts and peanuts</label><label class="t2-check"><input type="checkbox" id="av-onion"> Onion and garlic</label></div>' +
      '<div class="tl-field"><label>Please tick any that apply to you</label>' +
      '<label class="t2-check"><input type="checkbox" id="sf-preg"> I am pregnant</label><label class="t2-check"><input type="checkbox" id="sf-t1"> I have type 1 diabetes</label>' +
      '<label class="t2-check"><input type="checkbox" id="sf-kid"> I have kidney disease</label><label class="t2-check"><input type="checkbox" id="sf-ins"> I take insulin</label></div>',
      {
        go: 'Make my 7-day plan',
        onReset: function () { setHeightMode('cm'); state = null; },
        calc: function (ctx) {
          var male = H.sv(root, 'sex') === 'm', hu = H.sv(root, 'hu'), hcm;
          var age = H.read(root, 'age', 'Age', 18, 90, null, null, ctx, 'years');
          var w = H.read(root, 'w', 'Weight', 30, 200, 35, 160, ctx, 'kg');
          if (hu === 'ft') {
            var ft = H.read(root, 'hft', 'Feet', 3, 7, null, null, ctx, 'ft'), inch = H.read(root, 'hin', 'Inches', 0, 11.9, null, null, ctx, 'in');
            if (!ctx.bad) {
              hcm = (ft * 12 + inch) * 2.54;
              if (hcm < 120 || hcm > 220) { q('#f-hft', root).classList.add('t2-field--err'); q('#e-hft', root).textContent = 'Height should be between 3 ft 11 in and 7 ft 3 in.'; ctx.bad = true; }
            }
          } else hcm = H.read(root, 'h', 'Height', 120, 220, 140, 205, ctx, 'cm');
          if (ctx.bad) return null;
          var preg = q('#sf-preg', root).checked, t1 = q('#sf-t1', root).checked, kid = q('#sf-kid', root).checked, ins = q('#sf-ins', root).checked;
          var consult = { k: 'consult', href: L.consult, label: 'Book a free consultation', primary: true };
          if (preg || t1 || kid) {
            return H.note('info', 'A personalised plan needs your doctor or dietitian', 'With pregnancy, type 1 diabetes or kidney disease, food choices need to be set by someone who knows your reports. We have not made a plan here. Our team can help you take the next step.') + H.ctas([consult]);
          }
          var bmr = 10 * w + 6.25 * hcm - 5 * age + (male ? 5 : -161);
          var need = bmr * H.num(H.sv(root, 'act')) + H.num(H.sv(root, 'goal'));
          var floor = male ? 1500 : 1200, floored = need < floor; if (floored) need = floor;
          var target = Math.round(need / 100) * 100;
          var o = { diet: H.sv(root, 'diet'), region: H.sv(root, 'reg'), noDairy: true, noGluten: q('#av-gluten', root).checked, noNuts: q('#av-nuts', root).checked, noOnion: q('#av-onion', root).checked };
          var seed = Math.round(w * 10 + hcm * 7 + age * 13 + target + o.diet.charCodeAt(0) * 31 + o.region.charCodeAt(0) * 17 + (o.noDairy ? 3 : 0) + (o.noGluten ? 5 : 0) + (o.noNuts ? 7 : 0) + (o.noOnion ? 11 : 0));
          var plan = buildPlan(o, target, seed);
          state = { plan: plan, o: o, day: 0, target: target, ins: ins, floored: floored, floor: floor, swaps: 0 };
          return view();
        }
      });

    function setHeightMode(m) {
      var hr = q('#hrow', root);
      hr.innerHTML = m === 'ft' ? H.nf('hft', 'Height (feet)', 'ft', null, { min: 3, max: 7, step: 1, def: 5 }) + H.nf('hin', 'Height (inches)', 'in', null, { min: 0, max: 11, step: 1, def: 3 }) : H.nf('h', 'Height', 'cm', null, { min: 120, max: 220, step: 1, def: 160 });
      H.paintAll(hr);
    }
    H.bindSeg(root, 'hu', setHeightMode);

    function targetCard() {
      var t = state.target;
      return '<p class="t2-range">' + t.toLocaleString('en-IN') + ' kcal a day<small>Your daily target, shared across 5 meals</small></p>' +
        H.stats([H.stat('Calories', t.toLocaleString('en-IN'), 'kcal'), H.stat('Carbs', round(t * 0.45 / 4, 0) + ' to ' + round(t * 0.50 / 4, 0), 'g'),
          H.stat('Protein', round(t * 0.18 / 4, 0) + ' to ' + round(t * 0.20 / 4, 0), 'g'), H.stat('Fibre', '25 or more', 'g')]);
    }
    function dayView(di) {
      var day = state.plan.days[di], tot = dayTotals(day), rows = SLOTS.map(function (s) {
        var e = day[s], ml = mealLine(e);
        return '<div class="dp-meal"><div class="dp-meal__main"><span class="dp-meal__slot">' + NAMES[s] + '</span><strong>' + esc(e.m.name) + '</strong>' +
          '<small>' + ml.portion + ' &middot; ' + esc(e.m.serving) + '</small></div>' +
          '<div class="dp-meal__nums"><b>' + ml.kcal + ' kcal</b><small>' + ml.carbs + ' g carbs</small><button type="button" class="t2-btn dp-swap" data-swap="' + s + '">Swap</button></div>' +
          '<div class="dp-alts" id="dp-alts-' + s + '" hidden></div></div>';
      }).join('');
      var cp = tot.kcal ? round(tot.c * 4 / tot.kcal * 100, 0) : 0;
      return rows + '<p class="dp-total"><b>Day total: ' + Math.round(tot.kcal) + ' kcal</b> &middot; carbs ' + Math.round(tot.c) + ' g (' + cp + '% of calories) &middot; protein ' + Math.round(tot.p) + ' g &middot; fibre ' + Math.round(tot.fib) + ' g</p>';
    }
    function groceryView() {
      return grocery(state.plan).map(function (g) {
        return '<div class="dp-gro"><h4>' + g.cat + '</h4><ul>' + g.items.map(function (i) { return '<li>' + esc(i.name) + ' <span class="t2-calc">' + (i.n > 1 ? 'x' + i.n : '') + '</span></li>'; }).join('') + '</ul></div>';
      }).join('');
    }
    function view() {
      var o = state.o, tabs = DAYS.map(function (d, i) { return '<button type="button" role="tab" data-day="' + i + '" aria-selected="' + (i === state.day) + '">' + d + '</button>'; }).join('');
      var jain = o.diet === 'j' ? H.note('info', 'Jain plan', 'This plan leaves out onion, garlic, potato and other root vegetables, fresh ginger and mushrooms.') : '';
      var ins = state.ins ? H.note('warn', 'You take insulin', 'Keep your meal timings regular and check your readings whenever you change what you eat. Do not change your dose without your doctor.') : '';
      var fl = state.floored ? H.note('warn', 'Minimum shown', 'Very low calorie targets are not safe without medical supervision, so we show a minimum of ' + state.floor.toLocaleString('en-IN') + ' kcal.') : '';
      return targetCard() + fl + ins + jain +
        '<div class="dp-tabs" role="tablist" id="dp-tabs">' + tabs + '</div><div id="dp-day">' + dayView(state.day) + '</div>' +
        '<div class="t2-sec"><h3>Grocery list for the week</h3><p class="t2-fine">Foods from any Indian market. The number shows how many meals use it.</p><div class="dp-gros" id="dp-gro">' + groceryView() + '</div></div>' +
        '<div class="t2-actions"><label class="t2-text-wrap" style="flex:1 1 200px"><span class="t2-fine" style="display:block;margin:0 0 4px">Name on the PDF (optional)</span><input class="t2-text" id="dp-name" type="text" maxlength="40" autocomplete="off"></label>' +
        '<button type="button" class="t2-btn t2-btn--primary" id="dp-pdf">Download as PDF</button></div>' +
        H.note('info', 'How this plan is made', 'Calories use the Mifflin-St Jeor equation times your activity level' + (H.num(H.sv(root, 'goal')) < 0 ? ', minus 500 kcal a day to lose weight gently' : '') + '. Meals are Indian dishes with a low or medium glycemic index, shared as breakfast 25%, mid-morning 10%, lunch 30%, evening 10% and dinner 25%. Nutrient values are approximate.') +
        '<p class="t2-fine">Next: <a href="' + L.carb + '">Carb counter</a> to check your own meals &middot; <a href="' + L.gi + '">Glycemic index lookup</a></p>' +
        H.ctas([{ k: 'kit', href: L.kit, label: 'Want 365 days of plans with doctor check-ins? See the Complete Metabolic Care Kit', primary: true }, { k: 'consult', href: L.consult, label: 'Free consultation' }],
          'I made a ' + state.target + ' kcal 7-day Indian diet plan on the Sugar Knocker diet plan generator.');
    }
    function renderDay() {
      q('#dp-day', root).innerHTML = dayView(state.day);
      [].forEach.call(root.querySelectorAll('#dp-tabs button'), function (b) { b.setAttribute('aria-selected', +b.getAttribute('data-day') === state.day ? 'true' : 'false'); });
      q('#dp-gro', root).innerHTML = groceryView();
    }
    function alternatives(s) {
      var di = state.day, near = [];
      for (var d = Math.max(0, di - 2); d <= Math.min(6, di + 2); d++) near.push(state.plan.days[d][s].m.id);
      var slotKcal = state.target * SHARE[s];
      var list = state.plan.pools[s].filter(function (m) { var rr = slotKcal / m.kcal; return near.indexOf(m.id) < 0 && rr >= 0.6 && rr <= 1.75; });
      if (list.length < 3) list = state.plan.pools[s].filter(function (m) { return near.indexOf(m.id) < 0; });
      var out = [], rand = state.plan.rand;
      while (out.length < 3 && list.length) out.push(list.splice(Math.floor(rand() * list.length), 1)[0]);
      return out;
    }

    root.addEventListener('click', function (e) {
      if (!state) return;
      var t = e.target.closest('[data-day]');
      if (t && t.closest('#dp-tabs')) { state.day = +t.getAttribute('data-day'); renderDay(); return; }
      var sw = e.target.closest('[data-swap]');
      if (sw) {
        var s = sw.getAttribute('data-swap'), box = q('#dp-alts-' + s, root);
        if (!box.hidden) { box.hidden = true; return; }
        var alts = alternatives(s);
        box.innerHTML = alts.length ? alts.map(function (m) {
          return '<button type="button" class="dp-alt" data-alt="' + m.id + '" data-slot="' + s + '"><strong>' + esc(m.name) + '</strong><small>' + esc(m.serving) + '</small></button>';
        }).join('') : '<p class="t2-fine">No other meals fit this slot with your choices.</p>';
        box.hidden = false; return;
      }
      var alt = e.target.closest('[data-alt]');
      if (alt) {
        var slot = alt.getAttribute('data-slot'), m = meals[+alt.getAttribute('data-alt')], day = state.plan.days[state.day];
        day[slot] = { m: m, k: Math.max(0.5, Math.min(2, qtr(state.target * SHARE[slot] / m.kcal))) };
        tune(day, state.target); state.swaps++; renderDay();
        H.track('tool_swap', 'dietplan'); return;
      }
      if (e.target.closest('#dp-pdf')) { printPlan(); }
    });

    function printPlan() {
      var nm = q('#dp-name', root).value.trim();
      var host = document.querySelector('.t2-print-host'); if (host) host.remove();
      host = document.createElement('div'); host.className = 't2-print-host'; host.style.display = 'none';
      var daysHtml = state.plan.days.map(function (day, i) {
        var tot = dayTotals(day);
        return '<h3 style="margin:12px 0 4px;font-size:14px">' + DAYS[i] + ' &middot; ' + Math.round(tot.kcal) + ' kcal, carbs ' + Math.round(tot.c) + ' g</h3><table><tbody>' + SLOTS.map(function (s) {
          var e = day[s], ml = mealLine(e);
          return '<tr><td style="width:18%">' + NAMES[s] + '</td><td>' + esc(e.m.name) + ' (' + ml.portion + ': ' + esc(e.m.serving) + ')</td><td style="width:16%">' + ml.kcal + ' kcal, ' + ml.carbs + ' g carbs</td></tr>';
        }).join('') + '</tbody></table>';
      }).join('');
      var gro = grocery(state.plan).map(function (g) { return '<p style="margin:6px 0"><b>' + g.cat + ':</b> ' + g.items.map(function (i) { return esc(i.name); }).join(', ') + '</p>'; }).join('');
      host.innerHTML = '<div class="t2-print">' + H.brand() + '<h1 style="font-size:20px">7-day Indian diet plan' + (nm ? ' for ' + esc(nm) : '') + '</h1><p>Target ' + state.target + ' kcal a day. Made on ' + new Date().toLocaleDateString('en-IN') + ' with the Sugar Knocker diet plan generator. For education only: share it with your doctor or dietitian before you follow it.</p>' +
        daysHtml + '<h2 style="font-size:16px;margin-top:16px">Grocery list</h2>' + gro + '</div>';
      document.body.appendChild(host);
      H.track('tool_cta_click', 'dietplan', { cta: 'pdf' });
      H.printReport(host);
    }
  };
})();
